import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import {Label} from "@irati/ui/src/Typography"

interface Props {
  index?: number | null
}

export const Wrapper = styled(Card)`
  .recharts-label {
    font-size: 10px;
    font-weight: 400;
    font-family: ${({theme}) => theme.font.default};
  }
  .recharts-cartesian-grid-horizontal line:last-child {
    display: none;
  }
`

export const Text = styled.text`
  fill: ${({theme}) => theme.colors.primary1};
`

export const YAxisLabel = styled(Label)`
  transform: rotate(-90deg);
  display: inline-block;
  position: relative;
  bottom: 280px;
  right: 80px;
`

export const XAxisLabel = styled(Label)`
  position: absolute;
  left: 50%;
`

export const TooltipWrapper = styled(Card)`
  width: 150px;
`

export const ChartWrapper = styled.div<Props>`
  width: calc(100% - 190px);
  ${({index}) =>
    index &&
    `
  .recharts-responsive-container {
    .recharts-wrapper{
      .recharts-surface{
        .recharts-scatter{
          .recharts-layer{
            .recharts-layer{
              .recharts-scatter-symbol:not(:nth-child(${index.toString()})){
                display: none;
              }
            }
          }
        }
      }
    }
  }`}
`
